import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PriceBandService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(form: any): any{
    return this.http.post(`${this.url}/priceband/create`, form);
  }

  delete(data: any): any{
    return this.http.post(`${this.url}/priceband/delete`, data);
  }

  getAllByOrganization(filter: any): any {
    return this.http.get(`${this.url}/pricebands/organization`, { params: filter });
  }

  getTypes(): any{
    return this.http.get(`${this.url}/priceband/types`);
  }
}
